module.exports = __webpack_public_path__ + "static/media/bg41.c8dc1397.jpg";